export function mqsync_update(vw, vh, rv_range, rv_group) {
  return {
    type: 'MQSYNC_UPDATE',
    vw: vw,
    vh: vh,
    rv_range: rv_range,
    rv_group: rv_group
  }
}
